import type { User } from '@tbitop/authentication';
import { useNutzerMandant } from '@tbitop/oneplatform-api';
import { UserCircle } from 'phosphor-react';

type ProfilUserProps = {
  user: User;
};

export const ProfilUser = ({ user }: ProfilUserProps) => {

  const currentMandant = useNutzerMandant();

  return (
    <div className="flex items-center mx-4 mb-4">
      <div><UserCircle className="block mx-auto mr-4" size={128} weight="regular" /></div>
      <div className="text-sm">
        <div>{user.displayName}</div>
        <div>{currentMandant?.anzeigename}</div>
      </div>
    </div>
  );
};
